import React from 'react';

/** Custom imports */
import { RecoverMailForm } from 'components/elements/RecoverMailForm';

export const RecoverMail = () => {
  return <RecoverMailForm></RecoverMailForm>;
};
